<template>
  <div class="row mt-3">
    <div class="col-xs-12">
      <div class="card">
        <div class="card__content">
          <div class="card__title">
            <h4>Documentos pendientes por enviar ({{ autorizacionDocumentos.documentosPendientesEnviar.length }})</h4>
          </div>
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <!-- <th v-show="!form.en_cola">
                    <div tooltip="Seleccionar todo" tooltip-position="right">
                      <label v-show="autorizacionDocumentos.documentosPendientesEnviar.length > 0" for="todos_doc_pen_env">
                        <input v-model="todosDocPendienteEnviar" @change="seleccionarTodos('P')" type="checkbox" id="todos_doc_pen_env">
                        <span>&nbsp;</span>
                      </label>
                    </div>
                  </th> -->
                  <th>Tipo de documento</th>
                  <th># Documento</th>
                  <th>Fecha de emisión</th>
                  <th>Cliente</th>
                  <th>Total</th>
                  <th>Error SRI</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-show="autorizacionDocumentos.documentosPendientesEnviar.length === 0">
                  <td :colspan="!form.en_cola?8:7">
                    <strong>No se encontró registros.</strong>
                  </td>
                </tr>
                <tr :class="{
                  'tr--canceled' : comprobante.tiene_error === 'S'
                }" v-for="(comprobante, index) in autorizacionDocumentos.documentosPendientesEnviar" :key="index">
                  <!-- <td v-show="!form.en_cola">
                    <label :for="'comprobante_pen_enviar' + index">
                      <input type="checkbox" :id="'comprobante_pen_enviar' + index" v-model="compSelecDocPenEnviar" :value="comprobante.id_comprobante">
                      <span>&nbsp;</span>
                    </label>
                  </td> -->
                  <td>
                    {{ comprobante.tipo_comprobante.descripcion }}
                  </td>
                  <td>{{ comprobante.numero_documento }}</td>
                  <td>{{ comprobante.fecha_emision_comprobante }}</td>
                  <td>{{ comprobante.cliente.nombre }}</td>
                  <td>{{ comprobante.valor_total !== null?'$' + parseFloat(comprobante.valor_total).toLocaleString(locale):'' }}</td>
                  <td>
                    {{ comprobante.tiene_error === 'S'?'Sí':'No' }}
                  </td>
                  <td class="table-actions">
                    <button class="btn-info btn--text" tooltip="Visualizar" type="button" @click="visualizarComprobante(comprobante)"><i class="fa fa-eye"></i></button>
                    <button @click="mostrarEventosComprobante(comprobante.id_comprobante)" type="button" class="btn-secondary btn--text" tooltip="Logs"><i class="fa fa-file-o"></i></button>
                    <!-- <button @click="reenviar(index, 'P')" v-show="comprobante.en_procesamiento === 'S' && comprobante.pendiente_envio === 'N'" type="button" class="btn-warning btn--text"><i class="fa fa-share"></i></button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 mt-2">
      <div class="card">
        <div class="card__content">
          <div class="card__title">
            <h4>Documentos en procesos de autorización ({{ autorizacionDocumentos.documentosProcesoAutorizacion.length }})</h4>
          </div>
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <!-- <th v-show="!form.en_cola">
                    <div tooltip="Seleccionar todo" tooltip-position="right">
                      <label v-show="autorizacionDocumentos.documentosProcesoAutorizacion.length > 0" for="todos_doc_proceso_autorizacion">
                        <input v-model="todosDocProcesoAutorizacion" @change="seleccionarTodos('A')" type="checkbox" id="todos_doc_proceso_autorizacion">
                        <span>&nbsp;</span>
                      </label>
                    </div>
                  </th> -->
                  <th>Tipo de documento</th>
                  <th># Documento</th>
                  <th>Fecha de emisión</th>
                  <th>Cliente</th>
                  <th>Total</th>
                  <th>Error SRI</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-show="autorizacionDocumentos.documentosProcesoAutorizacion.length === 0">
                  <td :colspan="!form.en_cola?8:7">
                    <strong>No se encontró registros.</strong>
                  </td>
                </tr>
                <tr :class="{
                  'tr--canceled' : comprobante.tiene_error === 'S'
                }" v-for="(comprobante, index) in autorizacionDocumentos.documentosProcesoAutorizacion" :key="index">
                  <!-- <td v-show="!form.en_cola">
                    <label :for="'comprobante_proceso_autorizacion' + index">
                      <input type="checkbox" :id="'comprobante_proceso_autorizacion' + index" v-model="compSelecDocProceAutorizacion" :value="comprobante.id_comprobante">
                      <span>&nbsp;</span>
                    </label>
                  </td> -->
                  <td>
                    {{ comprobante.tipo_comprobante.descripcion }}
                  </td>
                  <td>{{ comprobante.numero_documento }}</td>
                  <td>{{ comprobante.fecha_emision_comprobante }}</td>
                  <td>{{ comprobante.cliente.nombre }}</td>
                  <td>{{ comprobante.valor_total !== null?'$' + parseFloat(comprobante.valor_total).toLocaleString(locale):'' }}</td>
                  <td>
                    {{ comprobante.tiene_error === 'S'?'Sí':'No' }}
                  </td>
                  <td class="table-actions">
                    <button class="btn-info btn--text" tooltip="Visualizar" type="button" @click="visualizarComprobante(comprobante)"><i class="fa fa-eye"></i></button>
                    <button @click="mostrarEventosComprobante(comprobante.id_comprobante)" type="button" class="btn-secondary btn--text" tooltip="Logs"><i class="fa fa-file-o"></i></button>
                    <!-- <button @click="reenviar(index, 'A')" v-show="comprobante.en_procesamiento === 'S' && comprobante.pendiente_envio === 'N'" type="button" class="btn-warning btn--text"><i class="fa fa-share"></i></button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.table-responsive {
  overflow-y: auto;
  max-height: 322px;
  width: 100%;
}
</style>
<script>
export default {
  props: {
    propAutorizacionDocumentos: {
      type: Object,
      required: true,
      default: () => ({
        documentosPendientesEnviar: [],
        documentosProcesoAutorizacion: [],
      }),
    }
  },
  data() {
    return {
      url,
      locale: locale,
      autorizacionDocumentos: this.propAutorizacionDocumentos,
      compSelecDocPenEnviar: [],
      compSelecDocProceAutorizacion: [],
      todosDocPendienteEnviar: false,
      todosDocProcesoAutorizacion: false,
      form: {
        en_cola: false,
      },
    }
  },
  methods: {
    seleccionarTodos: function (tipoDoc = null) {
      if(tipoDoc === 'P'){
        if (this.todosDocPendienteEnviar)
          for (let i = 0; i < this.autorizacionDocumentos.documentosPendientesEnviar.length; i++)
            this.compSelecDocPenEnviar.push(this.autorizacionDocumentos.documentosPendientesEnviar[i].id_comprobante);
        else 
          this.compSelecDocPenEnviar = [];
      }
      else if (tipoDoc === 'A'){
        if (this.todosDocProcesoAutorizacion)
          for (let i = 0; i < this.autorizacionDocumentos.documentosProcesoAutorizacion.length; i++)
            this.compSelecDocProceAutorizacion.push(this.autorizacionDocumentos.documentosProcesoAutorizacion[i].id_comprobante);
        else 
          this.compSelecDocProceAutorizacion = [];
      }
    },
    visualizarComprobante: function (comprobante) {
      window.open(this.url + '/comprobantes?tipo_comprobante=' + comprobante.id_tipo_comprobante + '&id_comprobante=' + comprobante.id_comprobante, '_blank');
    },
    mostrarEventosComprobante: function (idComprobante) {
      window.open(this.url + '/comprobantes/' + idComprobante + '/logs', '_blank');
    },
    enviarComprobantes: function(tipoDoc = null){
      let comp = null;
      if (tipoDoc === 'P')
        comp = this.compSelecDocPenEnviar;
      else if (tipoDoc === 'A')
        comp = this.compSelecDocProceAutorizacion;
      if (comp.length > 0) {
        swal({
          title: '¿Deseas autorizar los comprobantes seleccionados?',
          text: "Se enviarán los comprobantes.",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText : 'Autorizar',
          cancelButtonText : 'Cancelar'
        }).then((result) => {
          if (result.value) {
            let that = this;
            axios.post(this.url + '/autorizacion-documentos', {
              comprobantes: comp
            }).then(function (response) {
              swal('Se ha enviado un total de: ' + response.data.comprobantesEnviados + ' comprobante(s).', 'Mensaje', 'success');
              that.comp = [];
              that.consultar();
            }).catch(function (error) {
              if (error !== undefined && error !== null) {
                let response = error.response;
                if (response !== undefined && response !== null) {
                  let status = response.status;
                  if (status === 422)
                    swal('Hubo un error de validación.', 'Error', 'error');
                  else
                    swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                }
              }
            });
          }
        });
    }
    else 
        swal('No ha seleccionado comprobante alguno.', 'Mensaje', 'warning');
    },
    reenviar: function (index, tipoDoc = null) {
      let comp = null;
      if (tipoDoc == 'P')
        comp = this.autorizacionDocumentos.documentosPendientesEnviar[index];
      else if (tipoDoc == 'A')
        comp = this.autorizacionDocumentos.documentosProcesoAutorizacion[index];
      if (comp !== undefined && comp !== null) {
        let that = this;
        swal({
          title: '¿Deseas re-enviar este comprobante?',
          text: "Esta acción requiere de confirmación.",
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Re-enviar',
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.value) {
            axios.post(url + '/comprobantes/reenviar/' + comp.id_comprobante).then(function (response) {
              if (tipoDoc == 'P')
                that.autorizacionDocumentos.documentosPendientesEnviar.splice(index, 1);
              else if (tipoDoc == 'A')
                that.autorizacionDocumentos.documentosProcesoAutorizacion.splice(index, 1);
              swal('El comprobante ha sido re-enviado.', 'Realizado', 'success');
            }).catch(function () {
              swal('Hubo un error, intente nuevamente.', 'Aviso', 'warning');
            });
          }
        });
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/DashboardAutorizacionDocumentos.vue